import { render, staticRenderFns } from "./UserLoginCodeForm.vue?vue&type=template&id=e2a5b70e&"
import script from "./UserLoginCodeForm.vue?vue&type=script&lang=js&"
export * from "./UserLoginCodeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports